/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: EmployeesRoutingModule
 * Purpose		: Routing module for Employees.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { EmployeesListComponent } from './EmployeesList.component';
import { EmployeesAddComponent }  from './EmployeesAdd.component';
import { EmployeesEditComponent } from './EmployeesEdit.component';
import { EmployeesDetailsComponent } from './EmployeesDetails.component';

const EmployeesRoutes: Routes = [
	{ path: 'Employees',  component: EmployeesListComponent },
	{ path: 'Employees/add', component: EmployeesAddComponent },
	{ path: 'Employees/:id', component: EmployeesEditComponent },
	{ path: 'Employees/Details/:id', component: EmployeesDetailsComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(EmployeesRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class EmployeesRoutingModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Employees/Employees-routing.module.ts